import { Icon } from '@aptuno/aptuno-ui';
import React from 'react';
import { FileUploadContainer, FormField, DragDropText, UploadFileBtn, Spinner } from './FileUpoad.styled';

const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 500000;

const FileUpload = ({
  label,
  dragDropText,
  onChange,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  fileInputField,
  isLoading = false,
  isInvalid = false,
  ...otherProps
}) => {
  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    onChange(newFiles);
  };

  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  return (
    <FileUploadContainer >
      <UploadFileBtn type="button" invalid={isInvalid} onClick={handleUploadBtnClick}>
        {!isLoading && <Icon icon="plus" height="13px" width="13px" />}
        {isLoading && <Spinner size={12}/>}
        <span>{label}</span>
      </UploadFileBtn>
      {dragDropText && <DragDropText>{dragDropText}</DragDropText>}
      <FormField type="file" ref={fileInputField} onChange={handleNewFileUpload} title="" value="" {...otherProps} />
    </FileUploadContainer>
  );
};

export default FileUpload;